import { render, staticRenderFns } from "./Pendapatan.vue?vue&type=template&id=2bc0ad65&scoped=true"
import script from "./Pendapatan.vue?vue&type=script&lang=js"
export * from "./Pendapatan.vue?vue&type=script&lang=js"
import style0 from "./Pendapatan.vue?vue&type=style&index=0&id=2bc0ad65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc0ad65",
  null
  
)

export default component.exports